import { useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';

const useGetSummaryStore = (storeId: string, isLazy = false) => {
  const dispatch = useAppDispatch();
  const summaryStore = storeSelectors.getSummaryStore();

  const mutate = () => {
    dispatch(storeActions.getSummaryStore.fetch(storeId));
  };

  useEffect(() => {
    if (!storeId) return;
    if (isLazy) return;
    mutate();
  }, [storeId]);

  return {
    summaryStore,
    mutate,
  };
};

export default useGetSummaryStore;
